import { Share2 } from "lucide-react";

import { JobDetails } from "../utils/helpers";

interface JobHeaderProps {
	jobDetails: JobDetails;
	baseUrl: string;
	onBack: () => void;
	onShare: () => void;
}

export function JobHeader({ jobDetails, baseUrl, onBack, onShare }: JobHeaderProps) {
	const handleShare = async () => {
		const shareUrl = `${baseUrl}jobs/${jobDetails?._id}`;
		const shareText = `Check out this opportunity for a ${jobDetails?.jobTitle} at ${jobDetails?.company?.company_name || ""}`;

		if (navigator.share) {
			try {
				await navigator.share({
					title: jobDetails?.jobTitle || "Job Opportunity",
					text: shareText,
					url: shareUrl,
				});
			} catch (err) {
				if ((err as Error).name === "AbortError") return;
			}
		} else {
			await navigator.clipboard.writeText(shareUrl);
		}

		onShare();
	};

	return (
		<div className="flex items-start justify-between flex-wrap mb-8">
			<button className="text-blue-600 hover:text-blue-700 inline-block text-sm" onClick={onBack}>
				&larr; Back to Job Listings
			</button>
			<button
				className="inline-flex items-center gap-2 text-gray-700 hover:text-gray-900 text-sm font-medium"
				onClick={handleShare}
			>
				<Share2 className="h-4 w-4" />
				Share
			</button>
		</div>
	);
}
